import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const SubtitleContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
  align-items: center;
  margin-top: 7px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const ClearButton = styled(Button).attrs({
  type: 'button',
  appearance: 'transparent',
  shape: 'square',
  'aria-label': 'clear',
})`
  background-image: url('/images/close-filled.svg');
  height: 13px;
  width: 13px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
`;
